export default {
    token: null,
    //agrupacionesNeo = [],
    productosNeoRestauranteTodos: [],
    productosNeo: [],
    productosNeoOpciones: [],
    //estos datos hay que tomarlos del negocio y/o restaurante
    url: '',
    centro: '',
    apikey: ''
}